// @flow
import EventDetail from 'components/event/EventDetail';
import { connect } from 'react-redux';
import type { DispatchType, StateType } from 'types/Actions';
import type { StateProps, DispatchProps } from 'components/event/EventDetail';
import type { EventType } from 'types/Event';

import { fetchEvent, eventFetched } from 'actions/eventActions';

const DynamicEventsCardContainer: any = connect(
  (state: StateType): StateProps => ({
    events: state.eventsState.events,
    event: state.eventState.event,
    status: state.eventState.status
  }),
  (dispatch: DispatchType): DispatchProps => ({
    fetchEvent: (slug: string) => dispatch(fetchEvent(slug)),
    eventFetched: (event: EventType) => dispatch(eventFetched(event))
  })
)(EventDetail);

export default DynamicEventsCardContainer;
